import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { filter, take, takeUntil } from "rxjs/operators";
import { BaseComponent, ContentService, HelperService, Order, OrderDiscountLineItem, OrderService, UserService } from "@mypxplat/xplat/core";

import { AppService, AvoService } from "@mypxplat/xplat/web/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-order-detail",
  templateUrl: "order-detail.component.html",
  standalone: false,
})
export class OrderDetailComponent extends BaseComponent implements OnInit {
  @Input() order: Order;
  @Output() goBackClicked = new EventEmitter<void>();
  specsExpanded: Record<string | number, boolean> = {};
  constructor(
    userService: UserService,
    public activatedRoute: ActivatedRoute,
    public contentService: ContentService,
    public helperService: HelperService,
    public appService: AppService,
    private _router: Router,
    public orderService: OrderService,
    public translate: TranslateService,
    private avoService: AvoService
  ) {
    super(userService);
  }

  ngOnInit() {
    // Fire Loaded a Page for Order Details page (only in My Fender)
    if (this.userService.appId === "fender") {
      this.avoService.avoInitted$
        .pipe(
          filter((v) => !!v),
          take(1),
          takeUntil(this.destroy$)
        )
        .subscribe(() => {
          const te = this.avoService.trackEvent();
          if (te && typeof te.loadedAPage === "function") {
            const pageName = this.order?.orderNumber ? `Order ${this.order.orderNumber}` : "Order Details";
            const page = this.avoService.getPageProperties({ pageName });
            const payload: any = {
              ...page,
              customDestinationPageName_: pageName,
            };
            te.loadedAPage(payload);
          }
        });
    }
  }

  /** Shipping discount when present (replaces shipping line in summary). */
  get shippingDiscount(): OrderDiscountLineItem | undefined {
    return this.order?.discountLineItems?.find((d) => d.targetType === "SHIPPING_LINE");
  }

  /** Line-item discounts only (shown as rows in summary; shipping discount is shown as shipping row). */
  get lineItemDiscounts(): OrderDiscountLineItem[] {
    return this.order?.discountLineItems?.filter((d) => d.targetType === "LINE_ITEM") ?? [];
  }

  /** Total should always match Shopify's totalPriceSet — use the canonical total directly. */
  get summaryTotal(): number {
    return this.order?.total ?? 0;
  }

  /** Refund amount for the summary row — the delta between original and post-refund order total. */
  get refundedTotal(): number {
    return this.order?.refundedAmount ?? 0;
  }

  goBack() {
    this.order = null;
    this.goBackClicked.emit();
  }
}
